import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";
import CustomTableHead from "../components/CustomTableHead";
import DatePicker from "react-datepicker";
import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import CustomPaginatorActions from "../components/CustomPaginatorActions";

import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import {
  getSorting,
  getNumberSorting,
  getFloatSorting,
} from "../components/Utils";
import { getErrorString } from "../display/ErrorStrings";

import ViewPdf from "../components/ViewPdf";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import SaveIcon from "@material-ui/icons/SaveOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import DeleteIcon from "@material-ui/icons/DeleteForeverOutlined";
import AddStopIcon from "@material-ui/icons/AddAlertOutlined";

import CircularProgress from "@material-ui/core/CircularProgress";
import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const columnData = [
  {
    id: "checkNumber",
    numeric: false,
    disablePadding: false,
    label: "Check No.",
  },
  { id: "amount", numeric: true, disablePadding: false, label: "Amount($)" },
  {
    id: "checkDate",
    numeric: false,
    disablePadding: false,
    label: "Check Date",
  },
  {
    id: "datePlaced",
    numeric: false,
    disablePadding: false,
    label: "Date Placed",
  },
  {
    id: "dateRemoved",
    numeric: false,
    disablePadding: false,
    label: "Date Removed",
  },
  {
    id: "datePresent",
    numeric: false,
    disablePadding: false,
    label: "Date Presented",
  },
  { id: "reason", numeric: false, disablePadding: false, label: "Notes" },
];

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  vCenterItems: {
    display: "flex",
    alignItems: "center",
  },

  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP + ACCOUNTS_TOOLBAR_HEIGHT + 10}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",
    position: "fixed",
    top: `${MAIN_CONTENT_TOP + ACCOUNTS_TOOLBAR_HEIGHT}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },

  formContent: {
    marginTop: `50px`,
    position: "absolute",
    marginLeft: "50px",
    marginRight: "50px",
  },

  redCell: {
    color: "red",
  },
  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

class StopPaymentsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      actionError: "",
      stops: [],
      totalAmount: "",
      selectedStopKey: 0,
      selectedStopObject: {},
      order: "asc",
      orderBy: "",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      totalCount: 0,
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      backendStartDate: "",
      backendEndDate: "",
      checkNumber: "",
      amount: "",
      checkDate: "",
      momentCheckDate: null,
      redrawCheckDate: false,
      reason: "",
      rerunSearch: false,
      viewAdd: false,
      viewUpdate: false,
      viewPopup: false,
      notifyString: "",
      viewConfirmDelete: false,
      viewPdf: false,
      canSearch: false,
      searchStopsInProgress: false,
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onCloseActionPopup = this.onCloseActionPopup.bind(this);
    this.handleDeleteStop = this.handleDeleteStop.bind(this);
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
    if (this.state.redrawCheckDate) {
      this.setState({ redrawCheckDate: false });
    }
  }

  reset() {
    let items = this.state.stops;
    items.length = 0;
    this.setState({ stops: items });
    this.setState({ rerunSearch: false });
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ rerunSearch: false });
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
    this.setState({ searchStopsInProgress: false });
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    if (this.state.rerunSearch && this.state.canSearch) {
      this.search(this.state.page, this.state.rowsPerPage, true);
    }
  }

  onCloseActionPopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ actionError: "" });
  }

  handleCancel(e) {
    e.preventDefault();
    this.props.onResult();
  }

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.stops);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (orderBy === "checkNumber") {
        data.sort(getNumberSorting(order, orderBy));
      } else if (orderBy === "amount") {
        data.sort(getFloatSorting(order, "rawAmount"));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      this.setState({ stops: data });
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    if (this.state.canSearch) {
      this.search(page, this.state.rowsPerPage, true);
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
    window.sco_large_items_per_page = event.target.value;
    if (this.state.canSearch) {
      this.search(this.state.page, event.target.value, true);
    }
  };

  handleSelectStop(event, itemKey) {
    if (this.props.uiExclusionsList.includes("STOP_EDIT")) {
      return;
    }
    let items = this.state.stops;
    let index;
    for (index = 0; index < items.length; index++) {
      if (items[index].key === itemKey) {
        this.setState({ selectedStopObject: items[index] });
        break;
      }
    }
    this.setState({ selectedStopKey: itemKey });
    this.setState({ checkNumber: items[index].checkNumber });
    this.setState({ amount: items[index].amount });
    this.setState({ checkDate: items[index].checkDate });
    //this.setState({ momentCheckDate: Moment(items[index].checkDate, BACKEND_DATE_FORMAT) });
    this.setState({ momentCheckDate: Moment(items[index].checkDate) });
    this.setState({ reason: items[index].reason });
    if (this.props.uiExclusionsList.includes("STOP_EDIT")) {
      this.setState({ viewUpdate: false });
    } else {
      this.setState({ viewUpdate: true });
    }
  }

  handleUnselectStop(e) {
    this.setState({ selectedStopKey: 0 });
    this.setState({ viewUpdate: false });
  }

  handleStartDate(date) {
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handlePdf(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }
  handleAdd(e, action) {
    e.preventDefault();
    if (this.props.viewOnly) {
      this.setState({
        actionError: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (this.state.viewUpdate) {
      this.handleUpdateStop(e, action);
    } else {
      // open add form
      if (action === 3) {
        this.setState({ checkNumber: "" });
        this.setState({ amount: "" });
        this.setState({ checkDate: "" });
        this.setState({ momentCheckDate: null });
        this.setState({ reason: "" });
        this.setState({ viewAdd: true });
      }
      // cancel add form
      else if (action === 2) {
        this.setState({ viewAdd: false });
      }
      // add stop payment
      else if (action === 1) {
        if (this.state.checkNumber == null || this.state.checkNumber === "") {
          this.setState({
            actionError: getErrorString(
              "stopPayment.checkNumber.error",
              "Check Number is required"
            ),
          });
          this.setState({ viewPopup: true });
          return;
        }
        if (this.state.amount == null || this.state.amount === "") {
          this.setState({
            actionError: getErrorString(
              "stopPayment.amount.error",
              "Amount is required"
            ),
          });
          this.setState({ viewPopup: true });
          return;
        }
        if (this.state.checkDate == null || this.state.checkDate === "") {
          this.setState({
            actionError: getErrorString(
              "stopPayment.checkDate.error",
              "Check Date is required"
            ),
          });
          this.setState({ viewPopup: true });
          return;
        }
        this.executeAction(1);
      }
    }
  }
  handleDeleteStop(e, action) {
    e.preventDefault();
    if (this.props.viewOnly) {
      this.setState({
        actionError: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    // open confirm dialog
    if (action === 3) {
      this.setState({ checkNumber: this.state.selectedStopObject.checkNumber });
      this.setState({ amount: this.state.selectedStopObject.amount });
      this.setState({ checkDate: this.state.selectedStopObject.checkDate });
      this.setState({ reason: this.state.selectedStopObject.reason });
      this.setState({ viewConfirmDelete: true });
    }
    // cancelled
    else if (action === 2) {
      this.setState({ viewConfirmDelete: false });
    }
    // confirm
    else if (action === 1) {
      this.executeAction(3);
      this.setState({ viewConfirmDelete: false });
    }
  }

  handleUpdateStop(e, action) {
    e.preventDefault();
    // cancelled
    if (action === 2) {
      this.setState({ viewUpdate: false });
    }
    // confirm
    else if (action === 1) {
      if (this.state.checkNumber == null || this.state.checkNumber === "") {
        this.setState({
          actionError: getErrorString(
            "stopPayment.checkNumber.error",
            "Check Number is required"
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.amount == null || this.state.amount === "") {
        this.setState({
          actionError: getErrorString(
            "stopPayment.amount.error",
            "Amount is required"
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.checkDate == null || this.state.checkDate === "") {
        this.setState({
          actionError: getErrorString(
            "stopPayment.checkDate.error",
            "Check Date is required"
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      this.executeAction(2);
    }
  }

  handleCheckNumber(e) {
    this.setState({ checkNumber: e.target.value });
  }

  handleAmount(e) {
    this.setState({ amount: e.target.value });
  }

  handleCheckDate(date) {
    this.setState({ momentCheckDate: date });
    if (date === null) {
      this.setState({ checkDate: "" });
    } else {
      this.setState({ checkDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }
  handleCheckDateOutsideClick(e) {
    this.setState({ redrawCheckDate: true });
  }

  handleReason(e) {
    this.setState({ reason: e.target.value });
  }

  handleSearch(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ page: 0 });
    this.setState({ orderBy: "" });
    this.setState({ canSearch: true });
    this.setState({ searchStopsInProgress: true });
    this.search(0, this.state.rowsPerPage, false);
  }

  validateDates() {
    let start = this.state.startDate;
    let end = this.state.endDate;
    if (start !== null && end !== null && end.isBefore(start, "day")) {
      this.setState({
        errorString: getErrorString(
          "general.error.endDate",
          "End Date is before Start Date"
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  search(page, rowsPerPage, sortIt) {
    this.reset();

    fetch("on_stop_payment_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        startDate: this.state.backendStartDate,
        endDate: this.state.backendEndDate,
        page: page,
        rowsPerPage: rowsPerPage,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          let newStops = reply.items;
          if (sortIt) {
            this.sort(this.state.orderBy, this.state.order, newStops);
          }
          this.setState({ stops: newStops });
          this.setState({ totalCount: reply.totalCount });
          this.setState({ totalAmount: reply.totalAmount });
          if (reply.numItems === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          }
        }
        this.setState({ searchStopsInProgress: false });
      })
      .catch((error) => {
        this.setState({ searchStopsInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  executeAction(actionCode) {
    fetch("on_stop_payment_action", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        action: actionCode,
        checkNumber: this.state.checkNumber,
        amount: this.state.amount,
        checkDate: this.state.checkDate,
        reason: this.state.reason,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ actionError: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ viewPopup: true });
          if (actionCode === 1) {
            this.setState({ viewAdd: false });
            this.setState({
              notifyString: "Your stop payment information has been saved.",
            });
          } else if (actionCode === 2) {
            this.setState({ viewUpdate: false });
            this.setState({
              notifyString: "Your stop payment information has been modified.",
            });
            this.setState({ selectedStopKey: 0 });
          } else if (actionCode === 3) {
            this.setState({ viewUpdate: false });
            this.setState({
              notifyString: "Your stop payment information has been deleted.",
            });
            this.setState({ selectedStopKey: 0 });
          }
          this.setState({ rerunSearch: true });
          this.setState({ errorString: "" });
        }
      })
      .catch((error) => {
        this.setState({
          actionError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  isSelected = (id) => this.state.selectedStopKey === id;

  getSearchObject() {
    let data = {
      transit: this.props.accountObject.transit,
      account: this.props.accountObject.account,
      startDate: this.state.backendStartDate,
      endDate: this.state.backendEndDate,
      secureToken: this.props.secureToken,
    };
    return data;
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const { order, orderBy, rowsPerPage, page } = this.state;
    const datePickerTopMargin = 10;
    let data = this.state.stops;
    let totalCount = this.state.totalCount;
    /*let myPdfUrl = 'on_stop_payments_pdf_request?transit=' +
			this.props.accountObject.transit +
			'&account=' + this.props.accountObject.account;
		if (this.state.backendStartDate.length > 0) {
			myPdfUrl += "&startDate=" + encodeURIComponent(this.state.backendStartDate);
		}
		if (this.state.backendEndDate.length > 0) {
			myPdfUrl += "&endDate=" + encodeURIComponent(this.state.backendEndDate);
		}*/
    let myPdfUrl = "on_stop_payments_pdf_request";
    return (
      <div id="myTopDiv">
        <div className={classes.toolbar}>
          {this.state.selectedStopKey > 0 && (
            <FormGroup row>
              <Typography variant="headline" color="textSecondary">
                &nbsp;&nbsp; {t("selectStop.label")}: &nbsp;&nbsp;
              </Typography>
              <Button
                color="primary"
                onClick={(event) => this.handleUnselectStop(event)}
              >
                <DeselectIcon />
                &nbsp;{t("deselect.button")}
              </Button>
              {this.props.accountsPerm.writeStopPayment && (
                <Button
                  color="primary"
                  onClick={(event) => this.handleAdd(event, 1)}
                >
                  <SaveIcon />
                  &nbsp;{t("save.button")}
                </Button>
              )}
              {this.props.accountsPerm.deleteStopPayment && (
                <Button
                  color="primary"
                  onClick={(event) => this.handleDeleteStop(event, 3)}
                >
                  <DeleteIcon />
                  &nbsp;{t("delete.button")}
                </Button>
              )}
            </FormGroup>
          )}
          {this.state.viewAdd > 0 && (
            <FormGroup row>
              <Typography variant="headline" color="textSecondary">
                &nbsp;&nbsp; {t("newStop.label")}: &nbsp;&nbsp;
              </Typography>
              <Button
                color="primary"
                onClick={(event) => this.handleAdd(event, 1)}
              >
                <SaveIcon />
                &nbsp;{t("save.button")}
              </Button>
              <Button
                color="primary"
                onClick={(event) => this.handleAdd(event, 2)}
              >
                <CancelIcon />
                &nbsp;{t("cancel.button")}
              </Button>
            </FormGroup>
          )}

          {!this.state.viewAdd && this.state.selectedStopKey === 0 && (
            <FormGroup row>
              <Typography color="primary" variant="h6">
                &nbsp;&nbsp;{t("stopPayments.button")}:&nbsp;&nbsp;
              </Typography>
              <div style={{ marginTop: datePickerTopMargin }}>
                <Typography variant="caption">
                  {t("startDatePlaced.label")}&nbsp;&nbsp;
                  {!this.state.redrawStartDate && (
                    <DatePicker
                      isClearable
                      disabledKeyboardNavigation
                      dateFormat="LL"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      selected={this.state.startDate}
                      onChange={(event) => this.handleStartDate(event)}
                      onClickOutside={(event) =>
                        this.handleStartDateOutsideClick(event)
                      }
                      popperContainer={CalendarContainer}
                    />
                  )}
                </Typography>
              </div>
              &nbsp;&nbsp;
              <div style={{ marginTop: datePickerTopMargin }}>
                <Typography variant="caption">
                  &nbsp;&nbsp;
                  {t("endDatePlaced.label")}&nbsp;&nbsp;
                  {!this.state.redrawEndDate && (
                    <DatePicker
                      isClearable
                      disabledKeyboardNavigation
                      dateFormat="LL"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      selected={this.state.endDate}
                      onChange={(event) => this.handleEndDate(event)}
                      onClickOutside={(event) =>
                        this.handleEndDateOutsideClick(event)
                      }
                      popperContainer={CalendarContainer}
                    />
                  )}
                </Typography>
              </div>
              <Tooltip title={t("searchStop.tip")}>
                <Button
                  color="primary"
                  onClick={(event) => this.handleSearch(event)}
                >
                  <SearchIcon />
                  &nbsp;{t("search.button")}
                </Button>
              </Tooltip>
              <Tooltip title={t("viewPdfReport.tip")}>
                <Button
                  color="primary"
                  onClick={(event) => this.handlePdf(event)}
                >
                  <PDFViewIcon />
                  &nbsp;{t("pdf.button")}
                </Button>
              </Tooltip>
              &nbsp;&nbsp;&nbsp;&nbsp;
              {this.props.accountsPerm.createStopPayment &&
                !this.props.uiExclusionsList.includes("STOP_EDIT") && (
                  <Tooltip title={t("addStop.tip")}>
                    <Button
                      color="primary"
                      onClick={(event) => this.handleAdd(event, 3)}
                    >
                      <AddStopIcon />
                      &nbsp;{t("addStop.tip")}
                    </Button>
                  </Tooltip>
                )}
            </FormGroup>
          )}
        </div>
        <div className={classes.tableWrapper}>
          {(this.state.viewAdd || this.state.viewUpdate) && (
            <Paper elevation={5}>
              <div>
                <FormGroup row>
                  <TextField
                    margin="dense"
                    id="checkNumber"
                    label={t("checkNumber.label")}
                    type="text"
                    required
                    disabled={this.state.viewUpdate}
                    defaultValue={this.state.checkNumber}
                    onChange={(event) => this.handleCheckNumber(event)}
                    onKeyPress={(event) => {
                      return event.charCode >= 48 && event.charCode <= 57
                        ? true
                        : event.preventDefault();
                    }}
                  />
                  &nbsp;&nbsp;
                  <TextField
                    margin="dense"
                    id="amount"
                    label={t("amount.header")}
                    type="text"
                    required
                    defaultValue={this.state.amount}
                    onChange={(event) => this.handleAmount(event)}
                    InputProps={{
                      inputComponent: AmountFormatCustom,
                    }}
                    InputLabelProps={{ shrink: this.state.amount.length > 0 }}
                  />
                  &nbsp;&nbsp;
                  <div
                    style={{ height: 50, marginTop: 3 * datePickerTopMargin }}
                  >
                    <Typography variant="caption">
                      {t("checkDate.label")}&nbsp;&nbsp;
                    </Typography>
                    {!this.state.redrawCheckDate && (
                      <DatePicker
                        isClearable
                        disabledKeyboardNavigation
                        dateFormat="LL"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        fixedHeight
                        popperModifiers={{
                          preventOverflow: {
                            enabled: true,
                          },
                        }}
                        selected={this.state.momentCheckDate}
                        onChange={(event) => this.handleCheckDate(event)}
                        onClickOutside={(event) =>
                          this.handleCheckDateOutsideClick(event)
                        }
                        popperContainer={CalendarContainer}
                      />
                    )}
                  </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <TextField
                    margin="dense"
                    id="reason"
                    label={t("notes.label")}
                    type="name"
                    defaultValue={this.state.reason}
                    onChange={(event) => this.handleReason(event)}
                  />
                </FormGroup>
              </div>
            </Paper>
          )}
          {this.state.viewPdf && (
            <ViewPdf
              history={this.props.history}
              secureToken={this.props.secureToken}
              onClosePopup={this.onClosePopup}
              postData={this.getSearchObject()}
              pdfUrl={myPdfUrl}
              page={page}
              rowsPerPage={rowsPerPage}
            />
          )}

          {this.state.totalCount === 0 &&
            this.state.errorString.length === 0 &&
            this.state.searchStopsInProgress && (
              <div>
                <CircularProgress className={classes.progress} />
              </div>
            )}

          {!this.state.viewAdd && this.state.selectedStopKey === 0 && (
            <div>
              <TablePagination
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={CustomPaginatorActions}
              />
              {this.state.canSearch && (
                <Paper>
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <CustomTableHead
                      order={order}
                      orderBy={orderBy}
                      columnData={columnData}
                      onRequestSort={this.handleRequestSort}
                    />
                    <TableBody>
                      {data.map((n) => {
                        const isSelected = this.isSelected(n.key);
                        return (
                          <TableRow
                            hover
                            className={classes.tableRow}
                            onClick={(event) =>
                              this.handleSelectStop(event, n.key)
                            }
                            key={n.key}
                            selected={isSelected}
                            title={t("viewDetail.label")}
                          >
                            <TableCell style={{ width: "10%" }}>
                              {n.checkNumber}
                            </TableCell>
                            <TableCell numeric={true} style={{ width: "10%" }}>
                              {n.amount}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {n.checkDate}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {n.datePlaced}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {n.dateRemoved}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {n.datePresent}
                            </TableCell>
                            <TableCell style={{ width: "20%" }}>
                              {n.reason}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                    {this.state.totalCount > 0 && (
                      <TableFooter className={classes.boldCell}>
                        <TableRow>
                          <TableCell className={classes.boldCell}>
                            {t("totalAmount.label")}
                          </TableCell>
                          <TableCell className={classes.boldCell}>
                            {this.state.totalAmount}
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    )}
                  </Table>
                </Paper>
              )}
            </div>
          )}
        </div>
        {this.state.viewPopup && this.state.actionError.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.actionError}
            error={true}
            onClosePopup={this.onCloseActionPopup}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewConfirmDelete && (
          <ConfirmDialog
            title={t("confirmDelete.label")}
            text={t("deleteStop.label")}
            onCloseConfirm={this.handleDeleteStop}
          />
        )}
      </div>
    );
  }
}

StopPaymentsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(StopPaymentsPage));
